import React, { useEffect, useState } from 'react';
import StockMetricTable from './StockMetricTable';
import PieChart from './PieChart';
import { readJsonFile } from './utils';
const PositionComponent = () => {

  const[data, setData] = useState([]);
  const [positionNames, setPositionNames] = useState([]);
  const [percentages, setPercentages] = useState([]);
  const [totalGain, setTotalGain] = useState(0);
  const [totalEquity, setTotalEquity] = useState(0);
  const [totalUnrealizedReturn, setTotalUnrealizedReturn] = useState(0);
  const [optionsReport, setOptionsReport] = useState([]);
  useEffect(() => {
    const fetchPositions = async () => {
        try {
            console.log("fetching position data");

            const url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_POSITION_SERVICE_DEV : "";
            const response = await fetch(url + '/positions');
            
            console.log("response:", response);
            const result = await response.json();
            const flattedResult = []
            const positions = []
            const percents = []
            let totalGainLocal = 0;
            let totalEquityLocal = 0;
            let totalUnrealizedReturnLocal = 0;
           Object.entries(result).forEach(([ticker, value]) => {
                value['ticker'] = ticker;
                flattedResult.push(value);
                positions.push(value['name']);
                percents.push(value['percentage']);

                totalGainLocal +=  parseFloat(value['equity_change']);
                totalEquityLocal += parseFloat(value['equity']);
           });

           setTotalGain(totalGainLocal.toFixed(2));
           setTotalEquity(totalEquityLocal.toFixed(2));
           totalUnrealizedReturnLocal = (totalGainLocal / (totalEquityLocal - totalGainLocal)) * 100;
           setTotalUnrealizedReturn(totalUnrealizedReturnLocal.toFixed(2));

           flattedResult.sort((a, b) => parseFloat(b.equity_change) - parseFloat(a.equity_change));


            console.log("flattedResult:", flattedResult);
            setData(flattedResult);
            setPositionNames(positions);
            setPercentages(percents);
        } catch (error) {
            console.error("Error fetch positions. ", error);
        }
    };

    fetchPositions();

    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const today_str = formatter.format(new Date());
    console.log(today_str);
    const fileName = `/data/options/${today_str}.json`;

    const LoadOptionsReport = async () => {
      try {
        const jsonData = await readJsonFile(fileName);
        setOptionsReport(jsonData);
      } catch (err) {
        console.error("error loading options report file.", err);
      }
    };

    LoadOptionsReport();

  }, []);

  const columns = [
    {
      Header: 'ticker',
      accessor: 'ticker', // accessor is the "key" in the data
    },
    {
      Header: 'Total Amount',
      accessor: 'equity',
    },
    {
    Header: 'price',
    accessor: 'price',
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',
    },
    {
      Header: 'Average buy_price',
      accessor: 'average_buy_price',
    },
    {
      Header: 'Gain/Loss',
      accessor: 'equity_change',
    },
//     {
//       Header: 'id',
//       accessor: 'id',
//     },
    {
      Header: 'intraday_percent_change',
      accessor: 'intraday_percent_change',
    },
    {
      Header: 'name',
      accessor: 'name',
    },
    {
      Header: 'pe_ratio',
      accessor: 'pe_ratio',
    },
    {
      Header: 'percent_change',
      accessor: 'percent_change',
    },
    {
    Header: 'percentage',
    accessor: 'percentage',
    },
    {
    Header: 'type',
    accessor: 'type',
    },
   ];

     const pieChartData = {
       labels: positionNames,
       datasets: [
         {
           data: percentages, // Data values for each label
           backgroundColor:[
                   'rgba(255, 99, 132, 0.2)',
                   'rgba(54, 162, 235, 0.2)',
                   'rgba(255, 206, 86, 0.2)',
                   'rgba(75, 192, 192, 0.2)',
                   'rgba(153, 102, 255, 0.2)',
                   'rgba(255, 159, 64, 0.2)',
           ]
         },
       ],
     };
    return (
        <React.Fragment>
            <div>
                <h1>Position Table</h1>
                <StockMetricTable columns={columns} data={data}></StockMetricTable>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '40px' }}>
              <div>
                <h2>Portfolio Summary</h2>
                <p>Total Equity: ${totalEquity}</p>
                <p>Total Gain/Loss: ${totalGain}</p>
                <p>Total Unrealized Return: {totalUnrealizedReturn}%</p>
              </div>

              <div style={{ width: '300px', height: '300px' }}>
                <h2>Portfolio Allocations</h2>
                <PieChart data={pieChartData} />
              </div>
            </div>
            <div>
              <h2>Options Report</h2>
              <pre>{JSON.stringify(optionsReport, null, 2)}</pre>
          </div>
        </React.Fragment>
    );
};

export default PositionComponent;
